import userApi from '../../api/user'
import * as types from '../mutation-types'

// initial state
const state = {
  withdrawList: [],
  pageSize: 10,
  pageIndex: 1,
  maxPageSize: 1
}

// actions
const actions = {
  getWithdraws ({ commit }, payload) {
    commit(types.SET_ACCOUNT_WITHDRAW_PAGEINDEX, { pageIndex: 1 })
    let promise = userApi.getAlreadyMoneyListData(
      {
        pageSize: state.pageSize,
        pageNo: state.pageIndex,
        category: payload.type,
        PlatformAgentID: payload.PlatformAgentID
      }).then(res => {
        if (!res) {
          return
        }
        console.log('已提现金额列表信息', res.data.result.paySettlements)
        commit(types.SET_ACCOUNT_WITHDRAW_MAXPAGESIZE, { pageCount: res.data.result.pageCount })
        var list = res.data.result.paySettlements
        commit(types.RECEIVE_WITHDRAW_LIST, { list })
      })
    return promise
  },
  // 加载更多
  loadMoreWithdraws ({ commit }, payload) {
    const pageNo = state.pageIndex + 1
    commit(types.SET_ACCOUNT_WITHDRAW_PAGEINDEX, { pageIndex: pageNo })
    let promise = userApi.getAlreadyMoneyListData(
      {
        pageSize: state.pageSize,
        pageNo: state.pageIndex,
        category: payload.type,
        PlatformAgentID: payload.PlatformAgentID
      }).then(res => {
        if (!res) {
          return
        }
        console.log('追加已提现金额列表信息', res.data.result.paySettlements)
        var list = res.data.result.paySettlements
        commit(types.APPEND_WITHDRAW_LIST, { list })
      })
    return promise
  }
}

// mutations
const mutations = {
  // 设置订单列表
  [types.RECEIVE_WITHDRAW_LIST] (state, { list }) {
    state.withdrawList = list
  },
  // 追加订单列表
  [types.APPEND_WITHDRAW_LIST] (state, { list }) {
    if (list && list.length > 0) {
      for (var i = 0; i < list.length; i++) {
        state.withdrawList.push(list[i])
      }
    }
  },
  // 设置最大页数
  [types.SET_ACCOUNT_WITHDRAW_MAXPAGESIZE] (state, { pageCount }) {
    state.maxPageSize = pageCount
  },
  // 设置当前页数
  [types.SET_ACCOUNT_WITHDRAW_PAGEINDEX] (state, { pageIndex }) {
    state.pageIndex = pageIndex
  }
}

// getters
const getters = {
  withdrawList: state => state.withdrawList,
  isWithdrawPageEnd: state => state.pageIndex >= state.maxPageSize
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/withdraw.js